import { render, staticRenderFns } from "./CommentListOnSlideMenu.vue?vue&type=template&id=6085f2c4&scoped=true"
import script from "./CommentListOnSlideMenu.vue?vue&type=script&lang=ts"
export * from "./CommentListOnSlideMenu.vue?vue&type=script&lang=ts"
import style0 from "./CommentListOnSlideMenu.vue?vue&type=style&index=0&id=6085f2c4&prod&lang=scss&scoped=true"
import style1 from "./CommentListOnSlideMenu.vue?vue&type=style&index=1&id=6085f2c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085f2c4",
  null
  
)

export default component.exports